import { Link } from "react-router-dom";
import { ClipboardText, AddressBook, Receipt, BellRinging, Bank, Sparkle } from "@phosphor-icons/react";
import { PageHeader } from "@/components/PageHeader";

const ACTIONS = [
  { to: "/app/jobs?new=1", icon: ClipboardText, title: "New Valuation Job", desc: "Log a fresh assignment from a bank branch", testid: "qa-job" },
  { to: "/app/clients?new=1", icon: AddressBook, title: "New Client", desc: "Add a borrower or property owner", testid: "qa-client" },
  { to: "/app/invoices?new=1", icon: Receipt, title: "New Invoice", desc: "Bill a branch or client for completed work", testid: "qa-invoice" },
  { to: "/app/followups?new=1", icon: BellRinging, title: "Log Follow-up", desc: "Set a reminder so nothing slips", testid: "qa-followup" },
  { to: "/app/branches?new=1", icon: Bank, title: "New Bank Branch", desc: "Onboard a new referral relationship", testid: "qa-branch" },
  { to: "/app/outreach/new", icon: Sparkle, title: "New Outreach Campaign", desc: "Let AI draft the pitch for you", testid: "qa-campaign" },
];

export default function QuickActions() {
  return (
    <div className="space-y-6" data-testid="quick-actions-page">
      <PageHeader overline="Dashboard" title="Quick Actions" subtitle="Jump straight into the thing you need to do" />
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {ACTIONS.map((a, i) => (
          <Link
            key={a.to}
            to={a.to}
            data-testid={a.testid}
            className="group relative overflow-hidden rounded-lg border border-border bg-white p-6 transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg stagger-in"
            style={{ animationDelay: `${i * 50}ms` }}
          >
            <div className="absolute right-0 top-0 h-16 w-16 -translate-y-6 translate-x-6 rounded-full bg-accent/10 transition-transform duration-300 group-hover:scale-150" />
            <a.icon size={26} weight="duotone" className="text-accent relative" />
            <div className="font-display font-semibold text-lg text-primary mt-4 relative">{a.title}</div>
            <div className="text-sm text-muted-foreground mt-1 relative">{a.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
